import api from '@/services/Api';

class AssociateMemberOrganizations {
  /**
   * Get all associate member organizations
   * @returns {AxiosPromise<any>}
   */
  static all() {
    return api.get('/ref/associate-member-organizations');
  }
}

export default AssociateMemberOrganizations;
